import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Spinner } from '@pnl/ui';
import { api } from '../lib/api';
import { setDisplayCurrency } from '../lib/format';
import { MobileSidebar, Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { TopPromoBar } from '../components/TopPromoBar';

export function TraderLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  // Moeda de exibição do app = mercado do trader (B3=R$, Forex=US$). Setado aqui,
  // na raiz, antes do <Outlet/> renderizar as páginas — cobre todos os formatBrl.
  const me = useQuery({ queryKey: ['trader-me'], queryFn: () => api.getTraderMe() });
  const marketCode = me.data?.trader?.marketCode;
  if (marketCode) setDisplayCurrency(marketCode === 'FOREX' ? 'USD' : 'BRL');

  return (
    <div className="bg-ink-950 text-ink-100 flex min-h-screen">
      <Sidebar />
      <MobileSidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMenuClick={() => setMobileOpen(true)} />
        <TopPromoBar />
        <main className="flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <div className="animate-fade-in mx-auto max-w-[1400px]">
            <Suspense
              fallback={
                <div className="flex min-h-[400px] items-center justify-center">
                  <Spinner size={24} />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}
